<script lang="ts">
  const ORDER = ["title", "description", "brand", "price", "listPrice", "stock"] as const;
  const LABELS: Record<string, string> = {
    title: "Title",
    description: "Description",
    brand: "Brand",
    price: "Price",
    listPrice: "List price",
    stock: "Stock",
  };

  let {
    fields = [],
  }: {
    fields?: string[];
  } = $props();

  const mapped = $derived(new Set(fields));
  const mappedOrdered = $derived(ORDER.filter((f) => mapped.has(f)));
  const count = $derived(mappedOrdered.length);
</script>

<div class="flex flex-wrap items-center gap-2" aria-label={`${count}/6 fields mapped`}>
  <span class="text-xs font-extrabold tracking-wide text-muted">{count}/6 FIELDS</span>
  {#if mappedOrdered.length}
    {#each mappedOrdered as field (field)}
      <span
        class="inline-flex items-center gap-1 rounded-full border border-success-border
          bg-success-bg px-2.5 py-1 text-xs font-bold text-success"
      >
        <span aria-hidden="true">✓</span>
        {LABELS[field]}
      </span>
    {/each}
  {:else}
    <span class="text-xs italic text-muted">No fields mapped</span>
  {/if}
</div>
